import { render, staticRenderFns } from "./PatientIcon.vue?vue&type=template&id=86826c76"
import script from "./PatientIcon.vue?vue&type=script&lang=js"
export * from "./PatientIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports